
import axios from "axios";
let WEBHOOK_URL =  "https://script.google.com/macros/s/AKfycbySWO_86HzzYMH-15AEzMcxO2IbYCRkPix9doCfmXT8C2a2tyyW69CqRzC5aSuWY2qpNA/exec";
let productWebhook_URL= "https://script.google.com/macros/s/AKfycbxAKYW3TMX9PZkGBcf2za3qIbrzfBSRJcuDh2UoHsRpAP_XHqwkD1Jc9Qt96RpxtshI/exec"
  export const sendEvent = async (userId: string, eventName: string, duration: number | null = null,
    name:string| null = null,
    mobile:string| null = null,
    email:string| null = null,
    is_invested: string | null = null,
    income_range:string| null = null,
  ) => {
    const payload = new FormData();
    payload.append("userId", userId);
    payload.append("eventName", eventName);
    payload.append("duration", duration?.toString() ?? "");
    payload.append("timestamp", new Date().toISOString());
    if(name && mobile && email){
      payload.append("name", name);
      payload.append("mobile", mobile);
      payload.append("email", email);
      payload.append("is_invested", is_invested);
      payload.append("income_range", income_range || "");
    }
  



    try {
      // const res = await axios.post(WEBHOOK_URL, payload);
      await fetch(WEBHOOK_URL, {
        method: "POST",
        mode: "no-cors",
        body: payload,
      });
      console.log("Event sent");
      // console.log("Event sent:", res.data);
    } catch (error) {
      console.error("Failed to send event:", error);
    }
  };
  

  export const sendCampgain = async (userId: string,utm_source: string | null = null, utm_medium: string | null = null, utm_campaign: string | null = null, utm_content:string| null = null,
  ) => {
    const payload = new FormData();
    payload.append("userId", userId);
    payload.append("utm_source", utm_source);
    payload.append("utm_medium", utm_medium);
    payload.append("utm_campaign", utm_campaign);
    payload.append("utm_content", utm_content);
 
    try {
      await fetch(productWebhook_URL, {
        method: "POST",
        mode: "no-cors", // ✅ fixes CORS
        body: payload,
      });
      console.log("Campaign sent");
    } catch (error) {
      console.error("Failed to send campaign:", error);
    }
  };


